export default "__VITE_ASSET__ikYvYWzb__"